export default "/react/telegaInIcon-9f69f167.svg";